/**
* Copyright 2012-2018, Plotly, Inc.
* All rights reserved.
*
* This source code is licensed under the MIT license found in the
* LICENSE file in the root directory of this source tree.
*/

'use strict';

// Simple helper functions
// none of these need any external deps

module.exports = function noop() {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly.js/src/lib/noop.js
// module id = 1127
// module chunks = 0